import React,{ useState } from 'react';
import { connect} from 'react-redux';
import {store} from '../../../../../app/store';
import { Divider, Loader, Modal, Button } from 'rsuite';
import {fetchMobilePhoneCode, signUp} from '../../../../../app/common/services/fetch.service';
import * as actionsAuth  from '../../../../../app/actions/auth/auth';
import * as actionsUser  from '../../../../../app/actions/user';
import { NuInsInputTextLabel, NuInsInputPasswordLabel, NuInsSelectGroupLabel,  NuInsInputNumLabel, NuInsSmsCodeLabel } from '../../elements/inputFieldsLabel';
import { CheckBoxCustom } from '../../elements/inputFields';
import { SecurityIcon } from "../../svg/iconDashSvg";
import countryCodes from '../../liabilityPolicy/common/countryCodes.json';
import CounterButton from '../../elements/CounterButton';

const countryCodesOptions = countryCodes.map((doc, i) => ({label: doc["COUNTRY_NAME"], value: doc["PHONE_CODE"], key: i+1, code: doc["COUNTRY_CODE"] , order: doc["VIEW_ORDER"]}))


const SignUpComponent = ({onForward}) => {

    const [loading, setLoading]         = useState(false);
    const [modalError, setModalError]   = useState({show: false, text: ''})

    const [signUpData, setSignUpData]   = useState({email: null, password: null, countryCode: '359' , smsCode: null});
    const [checkFields, setCheckFields] = useState({});

    const errorMsg = "Полето е задължително";

    const onChangeHandler = (field, data) =>  {
        if(field === 'countryCode' && data) {
            data = data.substring(1);
        }

        setSignUpData({ ...signUpData , [field]:data });
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const emailValidation = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
    const passwordValidation = (password) => {
        const cyrLetters = `аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ`;
       // (?=.*\d)          // should contain at least one digit
       // (?=.*\D)          // should contain at least one non-digit
       // (?=.*[a-zA-Z${cyrLetters}]) // should contain at least one letter
       // [\Da-zA-Z0-9${cyrLetters}]{6,}   // should contain at least 6 from the mentioned characters
        let regexPassword = `^(?=.*\\d)(?=.*\\D)(?=.*[a-zA-z${cyrLetters}])[\\D0-9a-zA-Z${cyrLetters}]{6,}$`;
        regexPassword = new RegExp(regexPassword);

        return password.match(regexPassword) ? false : true;
    }

    const phoneValidation = () => {
        if(signUpData.countryCode  && signUpData.phoneNo && signUpData.phoneNo.length === 9  ) return false;

        return true;
    }

    const checkForError = (field, type, allFields) =>  {
        
        switch (type) {
            case 'email':
                return (checkFields[field] || allFields) && (!signUpData[field] || !emailValidation(signUpData[field]));
            case 'password':
                return (checkFields[field] || allFields) && (!signUpData[field] || passwordValidation(signUpData[field]));
            case 'phoneNo':
                return (checkFields[field] || allFields) && (!signUpData[field] || phoneValidation());
            default:
                return (checkFields[field] || allFields) && !signUpData[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'email':
                if(!signUpData[field]) return errorMsg;
                if(signUpData[field] && !emailValidation(signUpData[field])) return "Невалиден имeил адрес";
                break
            case 'password':
                if(!signUpData[field]) return errorMsg;
                if(signUpData[field] && passwordValidation(signUpData[field])) return "Невалидна парола";
                break
            case 'phoneNo':
                if(!signUpData[field]) return errorMsg;
                if(signUpData[field] && phoneValidation()) return "Невалиден номер";
                break
            default:
                return errorMsg;
        }
    }

    const validateForCode = () => {
        if(!signUpData.email || !emailValidation(signUpData.email)) return false;
        if(!signUpData.password || passwordValidation(signUpData.password)) return false;
        if(!signUpData.countryCode || !signUpData.phoneNo || phoneValidation()) return false;

        return true
    }

    const focusFirstCodeField = () => {    
        const el = document.getElementById("sms-1");
        if (el) el.focus();
      };

    const generateSmsCode = async () => {
        if(validateForCode()) {
        //if(true) {
            const phone = `${signUpData.countryCode}${signUpData.phoneNo}`;

            await store.dispatch(actionsAuth.validateAndRefreshTokens());

            let res;

            try{
                res = await fetchMobilePhoneCode(phone);
              } catch (error) {
                console.log(error);
              }

            if(res && res?.data) {
                const data = res.data;

                if(data.status === 0) {
                    //code is succesfully send
                    focusFirstCodeField();
                } else if (data.status === 1 ) {
                    if(data.globalErrors && data.globalErrors[0]?.defaultMessage === "UNIQUE.PHONE.VIOLATION") {
                        setModalError({
                            show: true,
                            text: "Профил с такъв телефонен номер вече съществува, използвай 'Забравена парола', за да възстановиш профила си!"
                        })
                    } else if (data.globalErrors && data.globalErrors[0]?.defaultMessage === "INVALID_OTP") {
                        setModalError({
                            show: true,
                            text: "Въведеният код е грешен"
                        })
                    } else {
                        setModalError({show: true, text: "Грешка, опитайте отново"})
                    }
                }
            }
        }
    }

    const onCodeEnteredHandle = (enteredCode) => {
        if(!enteredCode || enteredCode.length !== 6 ) return;

        setSignUpData({ ...signUpData , smsCode: enteredCode });
    }

    const validateAll = () => {
        if(validateForCode() && signUpData.smsCode) return true;

        return false;
    }

    const closeModal = () => setModalError({show: false, text: ""})

    const goForward = () => {
        onForward();
    }

    const submitHandler = async () => {
        //refreshLoginToken();
       // getLoginToken((signUpData.countryCode + signUpData.phoneNo), signUpData.password);
        // return goForward();

        if(validateAll()) {
            const countryData = countryCodes.find(doc=>(doc["PHONE_CODE"] === ('+' + signUpData.countryCode)));
            const countryCode = countryData["COUNTRY_CODE"];  // This will not separate US from Canada to be fixed later!

            const body = {
                operation       : "SIGN_UP",
                mobTelephone    : signUpData.countryCode + signUpData.phoneNo,
                email           : signUpData.email,
                password        : signUpData.password,
                countryCode,
                defaultCcy      : "BGN", // To DO
                verificationCode: signUpData.smsCode
            }

            await store.dispatch(actionsAuth.validateAndRefreshTokens());

            let res;

            try{
                res = await signUp(body);
              } catch (error) {
                console.log(error);
              }

            if(res && res?.data) {
                const data = res.data;
                if(data.status === 0) {
                    setLoading(true);
                    await store.dispatch(actionsAuth.getLoginToken((signUpData.countryCode + signUpData.phoneNo), signUpData.password));
                    await store.dispatch(actionsUser.updateUserDetails({phone:{countryCode: signUpData.countryCode, phoneNo: signUpData.phoneNo}}));
                    setLoading(false);
                    goForward();
            
                } else if (data.status === 1 ) {
                    if(data.globalErrors && data.globalErrors[0]?.defaultMessage === "UNIQUE.PHONE.VIOLATION") {
                        setModalError({
                            show: true,
                            text: "Профил с такъв телефонен номер вече съществува, използвай 'Забравена парола', за да възстановиш профила си!"
                        })
                    } else if (data.globalErrors && data.globalErrors[0]?.defaultMessage === "INVALID_OTP") {
                        setModalError({
                            show: true,
                            text: "Въведеният код е грешен"
                        })
                    } else {
                        setModalError({show: true, text: "Грешка, опитайте отново"})
                    }
                }
            }
        }
    }

    return (
        <>
            {loading 
            ? <Loader backdrop center size="lg" speed="slow" /> 
            : <>
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('email', data)} onBlur={()=>onBlurHandler('email')}
                                    slice={50}                            
                                    placeholder={"Email"} 
                                    value={signUpData.email} 
                                    error={checkForError('email', 'email')} 
                                    errorMsg={generateErrorMsg('email', 'email')}
                                    styles={{marginBottom: '20px'}}
                                    />
            <NuInsInputPasswordLabel onChange={(data)=>onChangeHandler('password', data)} onBlur={()=>onBlurHandler('password')}
                                    slice={30}                            
                                    placeholder={"Парола"} 
                                    value={signUpData.password} 
                                    error={checkForError('password', 'password')} 
                                    errorMsg={generateErrorMsg('password', 'password')}
                                    />
            <p className="secondary-text" style={{margin: '0 2rem 20px 2rem', fontSize: '10px'}}>
                Паролата ти трябва да е с дължина поне 6 символа и да съдържа поне една цифра и една буква</p>

            <div className="address-telephone-container" style={{marginBottom: '20px'}}>          
                <NuInsSelectGroupLabel onChange={(data)=>onChangeHandler('countryCode', data)}
                value={'+' + signUpData.countryCode}
                placeholder={"Телефон"}
                options={countryCodesOptions} 
                ></NuInsSelectGroupLabel>
                <div style={{marginLeft:'4px'}}>
                    <NuInsInputNumLabel onChange={(data)=>onChangeHandler('phoneNo', data)} onBlur={()=>onBlurHandler('phoneNo')}
                                        validationType={"vin"} slice={9} 
                                        value={signUpData.phoneNo}
                                        placeholder={" "}                                  
                                        error= {checkForError('phoneNo', 'phoneNo')}
                                        errorMsg={generateErrorMsg('phoneNo', 'phoneNo')}
                                        /> 
                </div>       
            </div>  
            <CounterButton onSubmit={generateSmsCode} disabled={!validateForCode()} />
            <Divider />
            <p style={{ textAlign: "left",paddingLeft: "2rem",color: "gray", marginTop: '-.5rem', marginBottom: '20px'}} > Код от SMS </p>  
            
            <NuInsSmsCodeLabel onChange={onCodeEnteredHandle}/>
            <Divider />
            <div className="steps_container-checkbox">
                <SecurityIcon />
                <div>След като генерираш код ще го получиш в SMS </div>
            </div>
            <div className="steps_container-checkbox">
                <CheckBoxCustom value={signUpData.acceptAdds} onChange={(data)=>onChangeHandler('acceptAdds', data)} />
                <div>Желая да получавам маркетингови съобщения по мейл </div>
            </div>

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" 
                    onClick={submitHandler} disabled={!validateAll()}>Продължи</button>
            </>
            }

             {/* Modal for representitive */}
             <Modal size="xs" show={modalError.show} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data" >{modalError.text}</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} >Ok</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default connect(null, {...actionsAuth})(SignUpComponent);